import * as d3 from 'd3'
export default {
  methods: {

    draw_Guidline() {
      
      this.pieSectors.forEach((d,i) => {

        this.canvasForms
        .append('line')
        .attr('x1', d.inX).attr('y1', d.inY)
        .attr('x2', d.outX).attr('y2', d.outY)
        .attr('stroke', this.guide.stroke)
        .attr('stroke-width', this.guide.sWidth)
          
        this.canvasForms
        .append('line')
        .attr('x1', d.outX).attr('y1', d.outY)
        .attr('x2', d.outX + d.direct).attr('y2', d.outY)
        .attr('stroke', this.guide.stroke)
        .attr('stroke-width', this.guide.sWidth)

        this.canvasForms
        .append('circle')
        .attr('fill', this.guide.bullet.color)
        .attr('cx', d.outX + d.direct).attr('cy', d.outY).attr('r', this.guide.bullet.size)

        let seriesGroup = this.canvasForms
        .append('g')
        .attr('id', `SERIES_GROUP_${i}_${this.localId}`)
        .attr('transform',`translate(${d.outX + d.direct + d.textSpace}, ${d.outY})`)
        
        seriesGroup
        .append('text') // title
        .attr('id', `SERIES_NAME_${i}_${this.localId}`)
        .attr('y', this.guide.series.tSize*0.36)
        .attr('font-size', this.guide.series.tSize).attr('fill', this.guide.series.tColor)
        .attr('text-anchor', d.align)
        .text(this.rawData[i].NAME)

        seriesGroup.append('text') // value
        .attr('id', `SERIES_VALUE_${i}_${this.localId}`)
        .attr('y', this.guide.value.tSize*0.36)
        .attr('font-size', this.guide.value.tSize).attr('fill', this.guide.value.tColor)
        .attr('text-anchor', d.align)
        .text(d.value.toFixed(this.guide.value.round) + this.guide.value.unit)

        let nameWidth = this.getNode(`#SERIES_NAME_${i}_${this.localId}`, 'width')

        d3.select(`#SERIES_VALUE_${i}_${this.localId}`).attr('transform', `translate(${nameWidth + 5},0)`)

        if (this.rawData[i].angle > 0.5) {
          d3.select(`#SERIES_GROUP_${i}_${this.localId}`).attr('transform', `translate(${d.outX + d.direct + d.textSpace},${d.outY})`)
          d3.select(`#SERIES_VALUE_${i}_${this.localId}`).attr('transform', `translate(${ -nameWidth - 5},0)`)
        }
      })
    },


  }
}
